/* eslint-disable */

import TableScreen from "@/lib/components/table/TableScreen";

export default class EmpresasUsuarios extends TableScreen {

    constructor(store) {

        //Nome do model

        super('empresasusuarios', 'aqui_vai_o_endpoint_do_export');

        this.$store = store;

        //aqui os campos que serão exibidos no header do grid
        this.headerDx = [

            { caption: "Empresa", dataField: "id_empresa", dataType: "string" },
            { caption: "Usuário", dataField: "id_usuario", dataType: "string" },
        ];

        this.defaultItem = {};

        this.editedItem = {};

        //Título da tela

        this.title = 'Empresas por Usuários';
        this.keyField = "id";
    }

    async getUsuarios(){
        return this.service.getWithOutPath('usuarios/list').then(
        res=> {
            return Promise.resolve(res);
        },
        error =>{
            return Promise.reject(error);
        });
        
    }
    async getEmpresas(){
        return this.service.getWithOutPath('empresas/list').then(
        res=> {
            return Promise.resolve(res);
        },
        error =>{
            return Promise.reject(error);
        });
        
    }

}